"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    _this.state = {
      uuid: (0, _v.default)()
    };
    _this.dropdown = _react.default.createRef();
    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "dropdown",
        ref: this.dropdown
      }, _react.default.createElement("button", {
        className: this.classes(),
        type: "button",
        id: this.state.uuid,
        onClick: this.toggleDropdown.bind(this)
      }, this.props.text, _react.default.createElement("span", {
        className: "caret"
      })), _react.default.createElement("ul", {
        className: "dropdown-menu",
        "aria-labelledby": this.state.uuid
      }, this.childrenRender()));
    }
  }, {
    key: "classes",
    value: function classes() {
      var classes = ['dropdown dropdown-toggle'];

      if (!this.props.buttonType || this.props.buttonType === 'none') {
        classes.push('btn-link');
      } else {
        classes.push('btn btn-' + this.props.buttonType);
      }

      return classes.join(' ');
    }
  }, {
    key: "childrenRender",
    value: function childrenRender() {
      return _react.default.Children.toArray(this.props.children).map(function (c, i) {
        return _react.default.createElement("li", {
          key: i
        }, c);
      });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.dropdown.current.classList.toggle('open');
    }
  }]);

  return Dropdown;
}(_react.default.Component);

var buttonTypes = ['default', 'primary', 'secondary', 'none'];
Dropdown.buttonTypes = {};
buttonTypes.forEach(function (s) {
  Dropdown.buttonTypes[s] = s;
});
Dropdown.defaultProps = {
  buttonType: Dropdown.buttonTypes.none,
  children: []
};
var _default = Dropdown;
exports.default = _default;